import React, {useEffect, useRef} from 'react';
import Hls from 'hls.js';

const HlsPlayer=({videoSrc,className})=>{
    const videoRef = useRef(null);

    useEffect(()=>{
        const video = videoRef.current;

        if (Hls.isSupported() && video) {
            const hls = new Hls();
            hls.loadSource(videoSrc);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play();
            });

            return () => hls.destroy();
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = videoSrc;
            video.addEventListener("loadedmetadata", () => {
                video.play();
            });
        }
    },[videoSrc]);

  return (<video ref={videoRef} controls className={className} style={{backgroundColor:'black'}}/>);   

}


export default HlsPlayer;